// import request from '@/utils/http'

// const BASE_URL = "https://api.openai.com/v1/completions";
const APIKEY = "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";

// // 请求chatGPT
// export const chatGPT = (model,prompt) => {
//     const data = {
//         model: model,
//         prompt: prompt,
//     }
//     return request.requestPostWithAuthorization(APIKEY,BASE_URL,data)
// };


const { Configuration, OpenAIApi } = require("openai");

const configuration = new Configuration({
    apiKey: APIKEY,
});
const openai = new OpenAIApi(configuration);

// const response = openai.createCompletion({
//     model: "text-curie-001",
//     prompt: "I am a highly intelligent question answering bot. If you ask me a question that is rooted in truth, I will give you the answer. If you ask me a question that is nonsense, trickery, or has no clear answer, I will respond with \"Unknown\".\n\nQ: What is human life expectancy in the United States?\nA: Human life expectancy in the United States is 78 years.\n\nQ: Who was president of the United States in 1955?\nA: Dwight D. Eisenhower was president of the United States in 1955.\n\nQ: Which party did he belong to?\nA: He belonged to the Republican Party.\n\nQ: What is the square root of banana?\nA: Unknown\n\nQ: How does a telescope work?\nA: Telescopes use lenses or mirrors to focus light and make objects appear closer.\n\nQ: Where were the 1992 Olympics held?\nA: The 1992 Olympics were held in Barcelona, Spain.\n\nQ: How many squigs are in a bonk?\nA: Unknown\n\nQ:美国总统是谁\nA:美国总统是唐纳德·特朗普。\n\nQ: 美国总统是谁 Unknown",
//     temperature: 0,
//     max_tokens: 100,
//     top_p: 1,
//     frequency_penalty: 0,
//     presence_penalty: 0,
//     stop: ["\n"],
// });

// 请求chatGPT
export const chatGPT = (model,prompt,temperature) => {
    return openai.createCompletion({
        model: model,
        prompt: prompt,
        temperature: temperature,
        max_tokens: 3000,
        top_p: 1,
        frequency_penalty: 0,
        presence_penalty: 0,
    })
};